import React from "react";
import { RouteNode } from "react-router5";
import { inject, observer } from "mobx-react";
import { ROUTE_RAW_QUALITIES } from "../../routes";
import Qualities from "./Qualities";
@inject((stores) => ({
  router: stores.router,
}))
@observer
class RawQualities extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Qualities type={"raw"} />;
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_RAW_QUALITIES}>
    {(routeProps) => <RawQualities {...routeProps} {...props} />}
  </RouteNode>
);
